import {FC, HTMLAttributes, ReactNode} from 'react';
import Icon, {IconProps} from 'components/Icon';
import {LayoutMethod} from 'hooks/useComponentPosition/types';
import {useTooltip} from '../hook';
import TooltipWrapper from '../index';
import {TooltipType} from '../types';

type TooltipIconProps = {
    href?: string;
    message: string | ReactNode;
    tooltipLayout?: LayoutMethod;
    tooltipType?: TooltipType;
} & HTMLAttributes<HTMLDivElement> &
    Partial<IconProps>;

const QuestionIcon: FC<HTMLAttributes<HTMLDivElement> & IconProps> = ({
    ...props
}) => {
    const {setTooltipRef} = useTooltip();

    return (
        <Icon ref={(r) => setTooltipRef(r)} role="complementary" {...props} />
    );
};

const TooltipIcon: FC<TooltipIconProps> = ({
    href,
    icon = 'question',
    message,
    size = 'lg',
    tooltipLayout = 'top-or-bottom',
    tooltipType = 'default',
    ...rest
}) => (
    <TooltipWrapper
        href={href}
        layoutMethod={tooltipLayout}
        message={message}
        tooltipType={tooltipType}
    >
        <QuestionIcon icon={icon} size={size} {...rest} />
    </TooltipWrapper>
);

export default TooltipIcon;
